module.exports = __webpack_public_path__ + "img/web-event.ed984ca3.webp";